import { scenarioFrameColor } from './ScenarioBadge';

type Props = {
  type: string | null | undefined;
};

/**
 * Full-viewport colored frame that reflects the current organization type,
 * mirroring trace-ui's workspace screen border. A single large outer
 * `box-shadow` paints everything outside a 3px inset rounded rectangle, so the
 * page content shows through the transparent middle.
 *
 * Renders nothing for `prod` (intentionally borderless) or unknown types.
 */
export const TypeScreenBorder = ({ type }: Props) => {
  const color = scenarioFrameColor(type);
  if (!color) {
    return null;
  }

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-[3px] z-50 rounded-[9px]"
      data-testid="type-screen-border"
      style={{ boxShadow: `0 0 0 100vmax ${color}` }}
    />
  );
};
